import { render } from "./CreateAccount.vue?vue&type=template&id=cafbc55a&scoped=true"
import script from "./CreateAccount.vue?vue&type=script&lang=js"
export * from "./CreateAccount.vue?vue&type=script&lang=js"

import "./CreateAccount.vue?vue&type=style&index=0&id=cafbc55a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cafbc55a"]])

export default __exports__